// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__x0vOx","description":"MealItem_description__FFLZE","price":"MealItem_price__3AxKl"};